import tw, { styled } from 'twin.macro';

import { ReactComponent as ArrowLeft } from './images/arrow-left.svg';
import { ReactComponent as ArrowRight } from './images/arrow-right.svg';

const CollapseToggle = styled.div(({ collapsed }: { collapsed: boolean }) => [
  tw`transition-transform duration-fast`,
  collapsed && tw`-scale-x-100`,
]);

interface CollapseButtonProps {
  direction: 'left' | 'right';
  collapsed: boolean;
}

export const CollapseButton = ({ collapsed, direction }: CollapseButtonProps) => {
  return <CollapseToggle collapsed={collapsed}>{direction === 'left' ? <ArrowLeft /> : <ArrowRight />}</CollapseToggle>;
};
